import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IframerComponent } from './shared/components/iframer/iframer.component';

const routes: Routes = [
  {
    path: 'annuaire',
    loadChildren:
      './directory/directory.module#DirectoryModule',
  },
  {
    path: 'iframe',
    component: IframerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
